<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center ">
      Grader Tidak Aktif
      <template v-if="role_status && role_status.status_create">
      <router-link 
      to="/user-manajemen/user-grader-tambah" 
      class="btn btn-success ml-auto">
        Tambah
      </router-link>
      </template>
    </CCardHeader>

    <!-- Tabs -->
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/user-manajemen/user-grader-aktif"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true">Aktif
          <span class="badge ml-1 badge-success text-white">{{ totalPetugasAktif }}</span>
        </router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/user-manajemen/user-grader-tidak-aktif"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="profile-tab"
          style="background-color:#486ba7"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false" >Tidak Aktif
          <span class="badge ml-1 badge-danger text-white">{{ totalPetugasTidakAktif }}</span>
        </router-link>
      </li>
    </ul>
    <!-- Tabs End -->

    <div class="card-body">
      <div class="row">
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
          />
          <br />
        </CCol>
      </div>

      <div class="row">
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>

            <template #no="{index}">
              <td class="py-2">{{ indexed == 0 ? index + 1 : index + indexed + 1 }}</td>
            </template>
            <template #name="{item}">
              <td class="py-2">{{item.name ? item.name : "-"}}</td>
            </template>
            <template #email="{item}">
              <td class="py-2">{{ item.email ? item.email : '-' }}</td>
            </template>
            <template #username="{item}">
              <td class="py-2">{{ item.username ? item.username : '-' }}</td>
            </template>            
            <template #instansi="{item}">
              <td class="py-2">{{ item.instansi ? item.instansi : '-' }}</td>
            </template>
            <template #noTelp="{item}">
              <td class="py-2">{{ item.noTelp ? item.noTelp : '-' }}</td>
            </template>
            <template #namaBank="{item}">
              <td class="py-2">{{ item.namaBank ? item.namaBank : '-' }}</td>
            </template>
            <template #noRekening="{item}">
              <td class="py-2">{{ item.noRekening ? item.noRekening : '-' }}</td>
            </template>
            <template #npwp="{item}">
              <td class="py-2">{{ item.npwp ? item.npwp : '-' }}</td>
            </template>
            
            <template #status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            
            <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center ">
                 <template v-if="role_status && role_status.status_update">
                <router-link :to="'/user-manajemen/user-grader-edit/' + item.id">
                  <CButton v-c-tooltip="'Ubah'" color="info" square class="btn-sm mr-1">
                    <font-awesome-icon icon="edit" />
                  </CButton>
                </router-link>&nbsp;&nbsp;
                 </template>
                 <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" square class="btn-sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                 </template>
              </td>
            </template>
          </CDataTable>

          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @change="pageChange"
          />
        </CCol>
      </div>
    </div>
  </CCard>
</template>
<script>
import UserGraderService from "../../../services/sertifikasi/user-grader.service";
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";
import { exportUtils } from '@/mixins/exportUtils';

const fields = [
  { key: "no" },
  { key: "name", label: "Nama" },
  { key: "username" },
  { key: "email" },
  { key: "instansi" },
  { key: "noTelp", label: "Nomor Telepon" },
  { key: "namaBank", label: "Bank" },
  { key: "noRekening", label: "No. Rekening" },
  { key: "npwp", label: "NPWP" },
  { key: "status", _style: " text-align: center" },
  { key: "aksi", _style: "width:10%; text-align: center" }
];

export default {
  name: "UserGraderTidakAktif",
  mixins : [
    AlertUtils,
    exportUtils,
    Pagination
  ],  
  data() {
    return {
      items: [],
      totalPetugasTidakAktif: 0,
      totalPetugasAktif: 0,
      actionPost: "",
      formData: {
        nama: "",
        email: "",
        no_telephone: "",
        tipe_petugas: "",
        kota: "",
        username: "",
        dibuat_pada: "",
        id: ""
      },
      pagination: {
        totalPages: 0,
      },
      search: "",
      pageSize: "10",  
      currentPage: 0,
      fields,
      details: [],
      indexed: 0,
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: [],
      role_status: null
    };
  },

  watch: {
    search: function (val) {
      clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {          
        vm.getData("0", vm.pageSize, vm.search);
      }, 1000);
    },
    
    currentPage: function(val) {      
      var page = val - 1;
      this.indexed = page * 10;      
      this.getData(val - 1, this.pageSize, this.search);      
    }
  },

  mounted() {
    this.getData(this.currentPage, this.pageSize, this.search)
    this.roleData();
  },
  methods: {
     roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === '/user-manajemen/user-grader-aktif' );  
      this.role_status = data;
    },
    pageChange() {
      this.getData(this.currentPage,this.pageSize,this.search)
    },

    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    
    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            UserGraderService.deleteUserGrader(this.formData)
              .then(response => {
                // comment console console.log(response);
                this.alertSuccess();
                this.getData(this.currentPage - 1, this.pageSize, this.search);
              })
              .catch(error => {
                this.alertError();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage,pageSize,filter) {
        let loader = this.$loading.show({
            container: false ? null : this.$refs.formContainer,
            canCancel: true,
            onCancel: this.onCancel
        });
        UserGraderService.getUserGraderTidakAktif(currentPage,pageSize,filter)
        .then(response => {            
            this.items = response.data.data.content;
            this.pagination.totalPages = response.data.data.totalPages;
            this.currentPage = response.data.data.pageable.pageNumber + 1;
            this.countData();
            setTimeout(() => loader.hide(), 1000);
        })
        .catch(error => {
            // comment console console.log(error);
        });
    },

    countData() {
      UserGraderService.getUserGraderAktif('0', '1000', 'default')
        .then(response => {
          this.totalPetugasAktif = response.data.data.content.length;
        })
        .catch(error => {
          // comment console console.log(error)
        });

      UserGraderService.getUserGraderTidakAktif('0', '1000', 'default')
        .then(response => {
          this.totalPetugasTidakAktif = response.data.data.content.length;
        })
        .catch(error => {
          // comment console console.log(error)
        })
    },
  }
};
</script>